<template>
  <div class="prop">
    <icon :icon="icon" size="sm"></icon>
    <span class="product_option">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import Icon from '../icon/Icon.vue';

export default {
  components: {
    Icon
  },
  props: [
      'icon'
  ]
}
</script>
